/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetAnimalCareSummaryQueryResponse, GetAnimalCareSummaryPathParams, GetAnimalCareSummary400, GetAnimalCareSummary401, GetAnimalCareSummary403, GetAnimalCareSummary404, GetAnimalCareSummary409, GetAnimalCareSummary500 } from "../../types/livestockController/GetAnimalCareSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAnimalCareSummary } from "../../client/livestockController/getAnimalCareSummary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAnimalCareSummaryQueryKey = (organizationId: GetAnimalCareSummaryPathParams["organizationId"] | undefined, animalId: GetAnimalCareSummaryPathParams["animalId"] | undefined) => [{ url: '/api/organizations/:organizationId/livestock/animals/:animalId/care', params: {organizationId:organizationId,animalId:animalId} }] as const

export type GetAnimalCareSummaryQueryKey = ReturnType<typeof getAnimalCareSummaryQueryKey>

export function getAnimalCareSummaryQueryOptions(organizationId: GetAnimalCareSummaryPathParams["organizationId"] | undefined, animalId: GetAnimalCareSummaryPathParams["animalId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAnimalCareSummaryQueryKey(organizationId, animalId)
        return queryOptions<GetAnimalCareSummaryQueryResponse, ResponseErrorConfig<GetAnimalCareSummary400 | GetAnimalCareSummary401 | GetAnimalCareSummary403 | GetAnimalCareSummary404 | GetAnimalCareSummary409 | GetAnimalCareSummary500>, GetAnimalCareSummaryQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && animalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getAnimalCareSummary(organizationId!, animalId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Sanitary summary for an animal: meat withdrawal standing, last deworming / ectoparasite control, open diseases, recent treatments, upcoming items and nutrition
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId/care}
 */
export function useGetAnimalCareSummary<TData = GetAnimalCareSummaryQueryResponse, TQueryData = GetAnimalCareSummaryQueryResponse, TQueryKey extends QueryKey = GetAnimalCareSummaryQueryKey>(organizationId: GetAnimalCareSummaryPathParams["organizationId"] | undefined, animalId: GetAnimalCareSummaryPathParams["animalId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetAnimalCareSummaryQueryResponse, ResponseErrorConfig<GetAnimalCareSummary400 | GetAnimalCareSummary401 | GetAnimalCareSummary403 | GetAnimalCareSummary404 | GetAnimalCareSummary409 | GetAnimalCareSummary500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getAnimalCareSummaryQueryKey(organizationId, animalId)
         

         const query = useQuery({
          ...getAnimalCareSummaryQueryOptions(organizationId, animalId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAnimalCareSummary400 | GetAnimalCareSummary401 | GetAnimalCareSummary403 | GetAnimalCareSummary404 | GetAnimalCareSummary409 | GetAnimalCareSummary500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}